import {
  SET_OWNED_CONNECTORS,
  SET_SHARED_CONNECTORS,
  SET_PURCHASED_CONNECTORS,
  ADD_SHARED_CONNECTORS,
  REMOVE_SHARED_CONNECTORS,
  UPDATE_SHARED_CONNECTOR
} from "redux/constants/portal";

export const setOwnedConnectors = (payload) => ({
  type: SET_OWNED_CONNECTORS,
  payload,
});

export const setPurchasedConnectors = (payload) => ({
  type: SET_PURCHASED_CONNECTORS,
  payload,
});

export const setSharedConnectors = (payload) => ({
  type: SET_SHARED_CONNECTORS,
  payload,
});

export const addSharedConnectors = (payload) => ({
  type: ADD_SHARED_CONNECTORS,
  payload,
});

export const removeSharedConnectors = (payload) => ({
  type: REMOVE_SHARED_CONNECTORS,
  payload,
});

export const updateSharedConnector = (payload) => ({
  type: UPDATE_SHARED_CONNECTOR,
  payload,
});
